<template>
  <div class="gmap-geo">
    <ui-button
      class="gmap-geo__button"
      :class="{ 'gmap-geo__button--translate': search.active }"
      :label="$t('geo.actions.dropdown')"
      button="cta"
      icon="world"
      @click.prevent="openModal"
    />
    <modal
      :title="$t('geo.modal.title')"
      class="gmap-geo__modal"
      name="geo"
      :has-apply="true"
      @apply="apply"
      :width="350"
    >
      <template slot="container">
        <filter-country
          class="gmap-geo__modal__sub-filters"
          v-if="subDivisions[currentKpi].subdivisions.length > 0"
          :country-obj="subDivisions[currentKpi]"
          :current-countries="currentCountries"
          @update="updateCountries"
        />
        <filter-sector
          v-if="sectors.length > 0"
          class="gmap-geo__modal__sub-filters"
          :sector-obj="sectors"
          :current-sectors="currentSectors"
          @update="updateSectors"
        />
      </template>
    </modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UiButton from '@/components/UI/Button.vue'
import FilterCountry from '@/components/Filter/Country.vue'
import FilterSector from '@/components/Filter/Sector.vue'
import { launchGAEvent } from '@/utils/gtm.util'

export default {
  name: 'GmapGeo',
  components: {
    UiButton,
    FilterCountry,
    FilterSector,
  },
  computed: {
    ...mapState({
      search: state => state.radar.search,

      subDivisions: state => state.data.subDivisions,
      brandZones: state => state.data.zones,
      dataSettings: state => state.data.settings,

      currentKpi: state => state.refine.currentKpi,
      currentCountries: state => state.refine.currentCountries,
      currentSectors: state => state.refine.currentSectors,
    }),
    brandZonesCurrentKPI() {
      return this.brandZones?.[this.currentKpi] || []
    },
    activeSetting() {
      return this.dataSettings.find(setting => setting.key === this.currentKpi)
    },
    sectors() {
      return this.activeSetting.sectors
    },
  },
  methods: {
    ...mapActions({
      updateCurrentCountries: 'refine/updateCurrentCountries',
      updateCurrentSectors: 'refine/updateCurrentSectors',
    }),
    openModal() {
      launchGAEvent(this.$route.params.id, `${this.$route.name}_geographic_filter`, 'clicks')
      this.$modal.show('geo')
    },
    apply() {
      this.$emit('refreshCountries')
    },
    updateCountries(countries) {
      this.updateCurrentCountries(countries)
    },
    updateSectors(sectors) {
      this.updateCurrentSectors(sectors)
    },
  },
}
</script>

<style lang="scss" scoped>
.gmap-geo {
  &__button {
    position: absolute;
    top: $gutter-sm;
    left: 50%;
    transform: translateX(-50%);
    transition: top $transition-duration-fast $transition-effect-default;

    @media (min-width: $screen-sm) {
      top: $gutter-md;
    }

    &--translate {
      top: calc(#{$button-min-height-desktop} + #{$gutter-sm} * 2);

      @media (min-width: $screen-sm) {
        top: calc(#{$button-min-height-desktop} + #{$gutter-md} * 2);
      }

      @media (min-width: $screen-md) {
        top: $gutter-md;
      }
    }
  }

  &__modal {
    &__sub-filters {
      margin-bottom: $spacing-sm;

      @media (min-width: $screen-sm) {
        margin-bottom: $spacing-md;
      }
    }

    &__sub-filters {
      &:last-child {
        margin-bottom: 0;

        @media (min-width: $screen-sm) {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
